<template>
  <div class="theory-qs" v-if="questionData">
    <div class="exam-question">
      {{ questionData?.index + 1 }}.（{{ questionData?.questionTypeName }}）{{
        questionData?.questionStem
      }}
      <img class="ques-tip" src="@/assets/images/exam/ques-icon.png" alt="" />
    </div>
    <el-checkbox-group
      @change="answer"
      class="exam-radio"
      v-if="questionData?.questionType == 3"
      v-model="answerData"
    >
      <el-checkbox
        v-for="(item, key) in questionData?.qaList"
        :key="key"
        :value="item.answerId"
      >
        {{ item.answerFLag }}.{{ item.answerStem }}</el-checkbox
      >
    </el-checkbox-group>
    <el-radio-group
      v-else
      @change="answer"
      class="exam-radio"
      v-model="answerData"
    >
      <el-radio
        v-for="(item, key) in questionData?.qaList"
        :key="key"
        :value="item.answerId"
      >
        {{ item.answerFLag }}.{{ item.answerStem }}</el-radio
      >
    </el-radio-group>
  </div>
</template>
<script setup>
import { defineExpose, ref, defineEmits } from "vue";
const emits = defineEmits(["success"]);
const answer = (val) => {
  emits("success", {
    question: questionData.value,
    answer: val
      ? Number(questionData.value.questionType) == 3
        ? val.sort((a, b) => a - b).join(",")
        : String(val)
      : null,
  });
};
const questionData = ref({});
const answerData = ref(null);
const open = (question, answer) => {
  questionData.value = question;
  if (Number(question.questionType) == 3) {
    answerData.value = answer ? answer.split(",").map((i) => Number(i)) : [];
  } else {
    answerData.value = answer ? Number(answer) : null;
  }
};

defineExpose({ open });
</script>
<style scoped lang="less">
.theory-qs {
  .exam-question {
    margin: 30px 0;
    padding: 18px 28px;
    background-color: #f9fafdff;
    border: 1px solid #d5e2fcff;
    border-radius: 10px;
    color: #475775ff;
    font-size: 22px;
    position: relative;
    line-height: 32px;
    .ques-tip {
      width: 14px;
      position: absolute;
      left: 8px;
      top: 26px;
    }
  }
  :deep(.exam-radio) {
    display: block;
    .el-radio {
      display: block;
      margin-bottom: 20px;
      width: max-content;
      .el-radio__input {
        vertical-align: baseline;
      }
      .el-radio__inner {
        border: 1px solid #c4cee1ff;
      }
      .el-radio__label {
        color: #475775ff;
        font-size: 22px;
        width: max-content;
      }
    }
    .el-checkbox {
      display: block;
      margin-bottom: 20px;
      width: max-content;
      .el-checkbox__input {
        vertical-align: baseline;
      }
      .el-checkbox__inner {
        border: 1px solid #c4cee1ff;
      }
      .el-checkbox__label {
        color: #475775ff;
        font-size: 22px;
        width: max-content;
      }
    }
  }
}
</style>
